<template>
    <section id="sobre">
        <div class="imagme" :style="{ 'background-image': 'url(' + imagem + ')' }"></div>
        <div class="texto">
            <h2 class="titulo">{{ $t('sobre.titulo') }}</h2>
            <div v-html="$t('sobre.texto')"></div>
        </div>
    </section>
</template>

<script>
import ImgSobre from '@/assets/img/home/fogo-do-grupo-workshop-samamaniacos.jpg'

export default {
    name: 'Sobre',
    data () {
        return {
            imagem: ImgSobre
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "../../../assets/sass/_mixin"

    #sobre
        display: flex
        padding-top: 100px
        @include device(mobile)
            &
                flex-direction: column
                padding-top: 80px
        .imagme
            width: 50%
            background-size: cover
            background-position: center
            @include device(mobile)
                &
                    width: 100%
                    display: list-item
                    height: 250px
                    background-attachment: fixed
                    background-position: center
                    background-repeat: no-repeat
                    background-size: cover
        .texto
            width: 50%
            padding: 50px
            display: flex
            flex-direction: column
            align-items: center
            justify-content: center
            text-align: center
            @include device(mobile)
                &
                    padding: 25px
                    width: 100vw
            h2
                @include device(mobile)
                    &
                        padding: 0
                        margin-top: 20px
</style>
